import { useState } from 'react';
import {
    Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField,
} from '@mui/material';

import { trocarSenha } from '../../services/usuarios';
import { atualizarExpiracao, limparSenhaTemporaria } from '../../services/auth';
import { mensagemErro } from '../../services/api';
import { useSnackbar } from '../../contexts/SnackbarContext';

// obrigatoria: primeiro acesso com senha temporária — não permite fechar sem trocar.
const TrocaSenhaDialog = ({ aberta, onFechar, obrigatoria = false }) => {
    const snackbar = useSnackbar();
    const [senhaAtual, setSenhaAtual] = useState('');
    const [novaSenha, setNovaSenha] = useState('');
    const [confirmacao, setConfirmacao] = useState('');
    const [salvando, setSalvando] = useState(false);

    const fechar = () => {
        setSenhaAtual('');
        setNovaSenha('');
        setConfirmacao('');
        onFechar();
    };

    const podeSalvar = !salvando && !!senhaAtual && novaSenha.length >= 6;

    const salvar = async () => {
        if (novaSenha !== confirmacao) {
            snackbar.aviso('A confirmação não confere com a nova senha.');
            return;
        }
        setSalvando(true);
        try {
            // A troca encerra as sessões anteriores; o back devolve a nova validade
            // (o cookie já vem renovado) para esta aba continuar autenticada.
            const sessao = await trocarSenha(senhaAtual, novaSenha);
            atualizarExpiracao(sessao?.expiraEm);
            limparSenhaTemporaria();
            snackbar.sucesso('Senha alterada com sucesso. As sessões abertas em outros dispositivos foram encerradas.');
            fechar();
        } catch (e) {
            snackbar.erro(mensagemErro(e, 'Não foi possível alterar a senha.'));
        } finally {
            setSalvando(false);
        }
    };

    return (
        <Dialog
            open={aberta}
            onClose={obrigatoria ? undefined : fechar}
            disableEscapeKeyDown={obrigatoria}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                component: 'form',
                onSubmit: (e) => { e.preventDefault(); if (podeSalvar) salvar(); },
            }}
        >
            <DialogTitle>{obrigatoria ? 'Defina sua nova senha' : 'Trocar senha'}</DialogTitle>
            <DialogContent>
                {obrigatoria && (
                    <Alert severity="info" sx={{ mb: 1 }}>
                        Sua senha é temporária. Por segurança, defina uma nova senha para continuar.
                    </Alert>
                )}
                <TextField
                    label="Senha atual"
                    type="password"
                    fullWidth
                    margin="normal"
                    autoFocus
                    value={senhaAtual}
                    onChange={(e) => setSenhaAtual(e.target.value)}
                />
                <TextField
                    label="Nova senha"
                    type="password"
                    fullWidth
                    margin="normal"
                    helperText="Mínimo de 6 caracteres"
                    value={novaSenha}
                    onChange={(e) => setNovaSenha(e.target.value)}
                />
                <TextField
                    label="Confirmar nova senha"
                    type="password"
                    fullWidth
                    margin="normal"
                    value={confirmacao}
                    onChange={(e) => setConfirmacao(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                {!obrigatoria && <Button type="button" onClick={fechar}>Cancelar</Button>}
                <Button type="submit" variant="contained" disabled={!podeSalvar}>
                    Salvar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default TrocaSenhaDialog;
